export type KVCameraViewJSON = {
  cameraViewId: string
  cameraViewName: string
  cameraViewNotes: string
  cameraViewPosition: string
  cameraViewRotation: string
  userName?: string
  userEmail?: string
  createdAt?: string
}

export class KVCameraView {
  id: string
  name: string
  notes: string
  cameraPosition: string
  cameraRotation: string
  userName: string
  userEmail: string
  createdAt: string

  constructor(id: string) {
    this.id = id
    this.name = ''
    this.notes = ''
    this.cameraPosition = ''
    this.cameraRotation = ''
    this.userName = ''
    this.userEmail = ''
    this.createdAt = new Date().toISOString()
  }

  static fromJSON(json: KVCameraViewJSON): KVCameraView {
    const cameraView = new KVCameraView(json.cameraViewId)
    if (json.cameraViewName) cameraView.name = json.cameraViewName
    if (json.cameraViewNotes) cameraView.notes = json.cameraViewNotes
    if (json.cameraViewPosition)
      cameraView.cameraPosition = json.cameraViewPosition
    if (json.cameraViewRotation)
      cameraView.cameraRotation = json.cameraViewRotation
    if (json.userName) cameraView.userName = json.userName
    if (json.userEmail) cameraView.userEmail = json.userEmail
    if (json.createdAt) cameraView.createdAt = json.createdAt
    return cameraView
  }

  static toJSON(cameraView: KVCameraView): KVCameraViewJSON {
    return {
      cameraViewId: cameraView.id,
      cameraViewName: cameraView.name,
      cameraViewNotes: cameraView.notes,
      cameraViewPosition: cameraView.cameraPosition,
      cameraViewRotation: cameraView.cameraRotation,
      userName: cameraView.userName,
      userEmail: cameraView.userEmail,
      createdAt: cameraView.createdAt,
    }
  }
}
